import React, { useState } from "react";
import firebase from "firebase";
import { Link } from "react-router-dom";
import * as DeviceDetect from "react-device-detect";
import { Spinner, Card } from "react-bootstrap";
import './brochure.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";


class RequestBrochure extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            basicFormCompleted: false,
            phoneNumber: window.localStorage.getItem("phoneCountryCode") ? window.localStorage.getItem("phoneCountryCode") : "+1",
            countryData: { "BD": "880", "BE": "32", "BF": "226", "BG": "359", "BA": "387", "BB": "+1-246", "WF": "681", "BL": "590", "BM": "+1-441", "BN": "673", "BO": "591", "BH": "973", "BI": "257", "BJ": "229", "BT": "975", "JM": "+1-876", "BV": "", "BW": "267", "WS": "685", "BQ": "599", "BR": "55", "BS": "+1-242", "JE": "+44-1534", "BY": "375", "BZ": "501", "RU": "7", "RW": "250", "RS": "381", "TL": "670", "RE": "262", "TM": "993", "TJ": "992", "RO": "40", "TK": "690", "GW": "245", "GU": "+1-671", "GT": "502", "GS": "", "GR": "30", "GQ": "240", "GP": "590", "JP": "81", "GY": "592", "GG": "+44-1481", "GF": "594", "GE": "995", "GD": "+1-473", "GB": "44", "GA": "241", "SV": "503", "GN": "224", "GM": "220", "GL": "299", "GI": "350", "GH": "233", "OM": "968", "TN": "216", "JO": "962", "HR": "385", "HT": "509", "HU": "36", "HK": "852", "HN": "504", "HM": " ", "VE": "58", "PR": "+1-787 and 1-939", "PS": "970", "PW": "680", "PT": "351", "SJ": "47", "PY": "595", "IQ": "964", "PA": "507", "PF": "689", "PG": "675", "PE": "51", "PK": "92", "PH": "63", "PN": "870", "PL": "48", "PM": "508", "ZM": "260", "EH": "212", "EE": "372", "EG": "20", "ZA": "27", "EC": "593", "IT": "39", "VN": "84", "SB": "677", "ET": "251", "SO": "252", "ZW": "263", "SA": "966", "ES": "34", "ER": "291", "ME": "382", "MD": "373", "MG": "261", "MF": "590", "MA": "212", "MC": "377", "UZ": "998", "MM": "95", "ML": "223", "MO": "853", "MN": "976", "MH": "692", "MK": "389", "MU": "230", "MT": "356", "MW": "265", "MV": "960", "MQ": "596", "MP": "+1-670", "MS": "+1-664", "MR": "222", "IM": "+44-1624", "UG": "256", "TZ": "255", "MY": "60", "MX": "52", "IL": "972", "FR": "33", "IO": "246", "SH": "290", "FI": "358", "FJ": "679", "FK": "500", "FM": "691", "FO": "298", "NI": "505", "NL": "31", "NO": "47", "NA": "264", "VU": "678", "NC": "687", "NE": "227", "NF": "672", "NG": "234", "NZ": "64", "NP": "977", "NR": "674", "NU": "683", "CK": "682", "XK": "", "CI": "225", "CH": "41", "CO": "57", "CN": "86", "CM": "237", "CL": "56", "CC": "61", "CA": "1", "CG": "242", "CF": "236", "CD": "243", "CZ": "420", "CY": "357", "CX": "61", "CR": "506", "CW": "599", "CV": "238", "CU": "53", "SZ": "268", "SY": "963", "SX": "599", "KG": "996", "KE": "254", "SS": "211", "SR": "597", "KI": "686", "KH": "855", "KN": "+1-869", "KM": "269", "ST": "239", "SK": "421", "KR": "82", "SI": "386", "KP": "850", "KW": "965", "SN": "221", "SM": "378", "SL": "232", "SC": "248", "KZ": "7", "KY": "+1-345", "SG": "65", "SE": "46", "SD": "249", "DO": "+1-809 and 1-829", "DM": "+1-767", "DJ": "253", "DK": "45", "VG": "+1-284", "DE": "49", "YE": "967", "DZ": "213", "US": "1", "UY": "598", "YT": "262", "UM": "1", "LB": "961", "LC": "+1-758", "LA": "856", "TV": "688", "TW": "886", "TT": "+1-868", "TR": "90", "LK": "94", "LI": "423", "LV": "371", "TO": "676", "LT": "370", "LU": "352", "LR": "231", "LS": "266", "TH": "66", "TF": "", "TG": "228", "TD": "235", "TC": "+1-649", "LY": "218", "VA": "379", "VC": "+1-784", "AE": "971", "AD": "376", "AG": "+1-268", "AF": "93", "AI": "+1-264", "VI": "+1-340", "IS": "354", "IR": "98", "AM": "374", "AL": "355", "AO": "244", "AQ": "", "AS": "+1-684", "AR": "54", "AU": "61", "AT": "43", "AW": "297", "IN": "91", "AX": "+358-18", "AZ": "994", "IE": "353", "ID": "62", "UA": "380", "QA": "974", "MZ": "258" },
            errorPhoneNumber: {},
            email: "",
            errorEmail: "",
            firstName: "",
            errorFirstName: "",
            lastName: "",
            errorLastName: "",
            countryCode: "",
            accessCountryCode: "",

            loadingSendOtp: false,
            otpSent: false,
            otp: "",
            errorOtp: "",
            loadingConfirmOtp: false,
            otpConfirmed: false,
            firstPhaseDone: false,

            leadId: "",
            previousUserData: {},
            previousEmail: "",
            previousEmailVerified: false,
            promptForEmail: false,
            selectedEmail: "",

            emailSentCard: false,
            emailSentTo: "",

            updateEmailCard: false,
            updatedEmail: "",
            confirmUpdatedEmail: "",
            emailNotFound: false,

            checkingUserData: true,


            usersRef: firebase.database().ref("users"),

            resendEmail: false,
            loadingResendEmail: false,

            changeEmail: false,
            loadingConfirmEmail: false,
            confirmEmail: "",
            checkConfirmEmail: false,

            timerOn: false,
            timerStart: 0,
            timerTime: 30000,
            otpResent: false,
            loadingResendOtp: false,

            updateEmailError: false
        };
    }

    async componentDidMount() {
        // Turn off phone auth app verification.
        // firebase.auth().settings.appVerificationDisabledForTesting = true;
        // if (firebase.auth().currentUser) {
        //     firebase.auth().signOut().then(() => console.log("signed out!"));
        // }

        // console.log("this.props", this.props);

        const userDetails = JSON.parse(window.localStorage.getItem("userDetails"));
        if (userDetails) {
            this.setState({
                firstName: userDetails.first_name,
                lastName: userDetails.last_name,
                email: userDetails.email,
                phoneNumber: userDetails.mobile
            })
        }


        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {
            size: "invisible"
        });

        fetch('https://05e4wl8tgc.execute-api.us-east-1.amazonaws.com/production/hello', { mode: 'cors', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': 'http://localhost:3000' } })
            .then((response) => response.json())
            .then((json) => {
                let country = json.input["CloudFront-Viewer-Country"]

                if (!window.localStorage.getItem("userDetails")) {
                    this.setState({
                        phoneNumber: `+${this.state.countryData[`${country}`]}`
                    })
                }

                this.setState({
                    isLoading: false,
                    countryCode: `${country}`,
                    accessCountryCode: `${country}`
                }, () => {
                    window.localStorage.setItem("phoneCountryCode", `+${this.state.countryData[`${country}`]}`)
                    window.localStorage.setItem("countryCode", `${country}`)
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    phoneNumber: `+1`,
                    isLoading: false
                })
            });


        // NEW APPROACH

        // firebase.auth().onAuthStateChanged(async (user) => {

        //     if (user) {
        //         const {
        //             leadId,
        //             firstName,
        //             lastName,
        //             email,
        //             selectedEmail,
        //             previousEmail
        //         } = this.state;

        //         this.setState({ checkingUserData: false });

        //         this.getData(firebase.database().ref("users").child(user.uid))
        //             .then((value) => {
        //                 this.setState({
        //                     basicFormCompleted: true,
        //                     previousUserData: value,
        //                     firstName: value.firstName,
        //                     lastName: value.lastName
        //                 })

        //                 if (value.email) {

        //                     if (value.emailVerified) {
        //                         // alert("User + Email found & verified")
        //                         this.setState({
        //                             previousEmail: value.email,
        //                             previousEmailVerified: true,
        //                             promptForEmail: true
        //                         })

        //                     } else {
        //                         // alert("User + Email found, but email not verified")
        //                         this.setState({
        //                             previousEmail: value.email,
        //                             previousEmailVerified: false,
        //                             promptForEmail: true
        //                         })

        //                     }
        //                 } else {
        //                     // alert("Only User found, but email does not found")

        //                     console.log("Please add an email")
        //                     this.setState({ updateEmailCard: true, emailNotFound: true })
        //                     if (this.state.email) {
        //                         this.setState({ updatedEmail: this.state.email })
        //                     }

        //                     // console.log("Generate Lead")
        //                     // this._generateLead(user, email);
        //                 }

        //             })
        //             .catch((error) => {
        //                 console.log("User didn't found, ", error);
        //                 // alert("User didn't found")

        //                 // console.log("Generate Lead")
        //                 this._generateLead(user);


        //                 user.updateProfile({
        //                     displayName: firstName + " " + lastName,
        //                     photoURL: 'https://firebasestorage.googleapis.com/v0/b/igesia-web.appspot.com/o/avatars%2Fusers%2Fsolo-icon.svg?alt=media&token=0279ff83-ebf4-420f-bc28-e5f6b10a7822'
        //                 })
        //                     .then(() => {
        //                         firebase
        //                             .database()
        //                             .ref("users")
        //                             .child(user.uid)
        //                             .set({
        //                                 leadId: leadId,
        //                                 timestamp: firebase.database.ServerValue.TIMESTAMP,
        //                                 displayName: user.displayName,
        //                                 name: user.displayName,
        //                                 firstName: firstName,
        //                                 lastName: lastName,
        //                                 avatar: user.photoURL,
        //                                 phoneNumber: user.phoneNumber,
        //                                 email: email,
        //                                 emailVerified: true,
        //                                 providerData: user.providerData,
        //                                 uid: user.uid,
        //                                 deviceInfo: DeviceDetect.deviceDetect(),
        //                                 deviceType: DeviceDetect.deviceType,
        //                                 device: DeviceDetect.isMobile ? DeviceDetect.isMobileOnly ? "Mobile" : "Tablet" : "Desktop",
        //                                 electron: DeviceDetect.isElectron ? true : false
        //                             }).then(() => {
        //                                 console.log("user saved");
        //                             });
        //                     })
        //                     .catch(err => {
        //                         console.error(err);
        //                     });

        //             });
        //     } else {
        //         this.setState({ checkingUserData: false });
        //     }
        // })

    }


    // _handlePromptWhichEmailToUse = async (selectedEmail) => {
    //     const user = firebase.auth().currentUser;

    //     // console.log("Generate Lead", user, selectedEmail)
    //     let leadGeneratedDone = await this._generateLead(user, selectedEmail);

    //     if (leadGeneratedDone) {
    //         this.setState({
    //             emailSentCard: true,
    //             emailSentTo: selectedEmail,
    //             updateEmailCard: false,
    //             promptForEmail: false,
    //             loadingConfirmEmail: false
    //         })
    //     }
    // }


    _generateLead = async (user, previousEmail = this.state.email) => {
        const { firstName, lastName } = this.state;
        const { programId, programType } = this.props;
        let sendBrochure = firebase.functions().httpsCallable('sendBrochure');

        // getting ref if it exists
        let ref = '';
        if(!(window.localStorage.getItem('ref'))){
            // no ref
        }else if(window.localStorage.getItem('ref')){
            const indexRef = window.localStorage.getItem('ref');
            if( indexRef[0] === "["){
                // new ds i.e array
                const LSRef = JSON.parse(window.localStorage.getItem('ref'));
                ref = LSRef[LSRef.length - 1];
            }else{
                ref = window.localStorage.getItem('ref');
                let newRef = [ref];
                window.localStorage.setItem('ref', JSON.stringify(newRef));
            }

        }

        // console.log("Inside Generate Lead", {
        //     firstName: firstName,
        //     lastName: lastName,
        //     email: previousEmail,
        //     phoneNumber: user.phoneNumber,
        //     uid: user.uid,
        //     programId: programId,
        //     programType: programType,
        //     timestamp: firebase.firestore.FieldValue.serverTimestamp()
        // })

        // console.log(user,'user', user.email, 'useremail');

        if (
            this._checkIfStringEmpty(firstName)
            && this._checkIfStringEmpty(previousEmail)
            && this._checkIfEmailValid(previousEmail)
            && this._checkIfStringEmpty(programId)
            && this._checkIfStringEmpty(programType)
        ) {
            let leadData = {
                firstName: firstName,
                lastName: lastName,
                email: previousEmail,
                phoneNumber: user.phoneNumber,
                // uid: user.uid,
                programId: programId,
                programType: programType,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                ref: ref
            };
            // console.log('in lead generator', leadData);

            let leadGenerated = await firebase
                .firestore()
                .collection("/Variants/pt-BR/leads/")
                .add(leadData)
                .then(function (docRef) {
                    console.log("Document written with ID: ", docRef.id);

                    sendBrochure({
                        leadGenerationId: docRef.id
                    })
                        .then(function (result) {
                            console.log("sendBrochure", result)
                        });

                    // firebase
                    //     .database()
                    //     .ref("users")
                    //     .child(user.uid)
                    //     .update({
                    //         email: previousEmail,
                    //         emailVerified: true
                    //     })

                    return docRef.id;
                })
                .catch(function (error) {
                    console.error("Error adding document: ", error);
                    return false;
                });

            if (leadGenerated) {
                this.setState({ leadId: leadGenerated })
                return true;
            } else {
                console.log("Cannot generate lead with this data, ", leadData);
                return false;
            }

        }
    }


    getData = (ref) => {
        return new Promise((resolve, reject) => {
            const onError = (error) => reject(error);
            const onData = (snap) => resolve(snap.val());

            ref.on("value", onData, onError);
        });
    };



    // NEW APPROACH

    _handleChange = event => {
        var pattern = /^\+[0-9\s\-\(\)]+$/;
        var patternOtp = /^[0-9]*$/;
        if (event.target.name === "phoneNumber") {

            if (event.target.value.match(pattern))
                this.setState({ [event.target.name]: event.target.value });

        } else if (event.target.name === "otp") {

            if (event.target.value.length <= 6 && event.target.value.match(patternOtp))
                this.setState({ [event.target.name]: event.target.value });

        } else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };


    _checkIfStringEmpty = val => val.length > 0;

    _checkIfEmailValid = email => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    _checkIfFormValid = () => {
        const { firstName, lastName, email, phoneNumber } = this.state;

        if (
            this._checkIfStringEmpty(firstName)
            && this._checkIfStringEmpty(email)
            && this._checkIfStringEmpty(phoneNumber)
            && this._checkIfEmailValid(email)
        ) {
            return true;
        }
        return false;
    }


    _handleSubmitAndGenerateOTP = event => {
        const {
            phoneNumber,
            firstName,
            lastName,
            email,
            countryCode,
            accessCountryCode
        } = this.state;

        event.preventDefault();

        let userDetails = {
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_code: countryCode,
            mobile: phoneNumber,
            access_country_code: accessCountryCode,
            address_details: {}
        }

        window.localStorage.setItem("userDetails", JSON.stringify(userDetails))

        if (this._checkIfFormValid()) {
            let user = {
                first_name: firstName,
                last_name: lastName,
                email: email,
                country_code: countryCode,
                phoneNumber: phoneNumber,
            }

            if(user.email === "shebucr7@gmail.com" || user.email === "me@iarani.com"){
                //dont make leads for these ids
            }else{
                this._generateLead(user, user.email);
            }

            

            if(this.leadId !== ''){
                this.props.history.push('/thankyou/');
            }


            // this.setState({ loadingConfirmOtp: false });



            // this.setState({ loadingSendOtp: true });

            // const appVerifier = window.recaptchaVerifier;

            // firebase
            //     .auth()
            //     .signInWithPhoneNumber(phoneNumber, appVerifier)
            //     .then(confirmResult => {
            //         // console.log("phoneNumber", phoneNumber);
            //         // console.log("confirmResult", confirmResult);
            //         window.confirmationResult = confirmResult;
            //         this.setState({
            //             otpSent: true,
            //             loadingSendOtp: false
            //         }, () => {
            //             this.handleTimer()
            //         });
            //     })
            //     .catch(err => {
            //         // console.log("phoneNumber", phoneNumber);
            //         console.error(err);
            //         this.setState({
            //             errorPhoneNumber: err,
            //             loadingSendOtp: false
            //         });
            //     });
        }
    }


    // _handleConfirmOTP = async () => {
    //     const { otp } = this.state;

    //     if (this._checkIfStringEmpty(otp)) {

    //         this.setState({ loadingConfirmOtp: true });

    //         let resultOfOTP = await window.confirmationResult.confirm(otp).then(function (result) {
    //             // User signed in successfully.
    //             // console.log("result", result);

    //             // var user = result.user;
    //             // console.log("user", user);

    //             // console.log("CurrentUser", firebase.auth().currentUser);
    //             return true;

    //         }).catch(function (error) {
    //             console.log(error);
    //             return false;
    //         });

    //         if (resultOfOTP) {
    //             console.log("OTP matches.")
    //             this.setState({ loadingConfirmOtp: false })
    //         } else {
    //             this.setState({
    //                 errorOtp: "Invalid OTP entered, please re-enter correct OTP.",
    //                 loadingConfirmOtp: false
    //             });
    //         }

    //     } else {
    //         this.setState({ errorOtp: "Please enter OTP" });
    //     }
    // }

    // _handleEmailUpdate = () => {
    //     const { updatedEmail, confirmUpdatedEmail } = this.state;
    //     this.setState({ loadingConfirmEmail: true });

    //     if (updatedEmail === confirmUpdatedEmail) {
    //         console.log("updatedEmail", updatedEmail)
    //         this._handlePromptWhichEmailToUse(updatedEmail);
    //     } else {
    //         this.setState({ 
    //             loadingConfirmEmail: false, 
    //             updateEmailError: true
    //         });
    //     }
    // }

    // handleTimer = () => {
    //     this.setState({
    //         timerOn: true,
    //         timerTime: this.state.timerTime,
    //         timerStart: this.state.timerTime
    //     });
    //     this.timer = setInterval(() => {
    //         const newTime = this.state.timerTime - 10;
    //         if (newTime >= 0) {
    //             this.setState({
    //                 timerTime: newTime
    //             });
    //         } else {
    //             clearInterval(this.timer);
    //             this.setState({ timerOn: false });
    //         }
    //     }, 10);
    // }


    // handleResendSubmit = event => {
    //     const { phoneNumber } = this.state;

    //     event.preventDefault();

    //     window.recaptchaVerifierResend = new firebase.auth.RecaptchaVerifier("recaptcha-container-resend", {
    //         size: "invisible"
    //     });

    //     if (this._checkIfFormValid()) {

    //         this.setState({ loadingResendOtp: true });

    //         const appVerifier = window.recaptchaVerifierResend;

    //         firebase
    //             .auth()
    //             .signInWithPhoneNumber(phoneNumber, appVerifier)
    //             .then(confirmResult => {
    //                 // console.log("phoneNumber", phoneNumber);
    //                 // console.log("confirmResult", confirmResult);
    //                 window.confirmationResult = confirmResult;
    //                 this.setState({
    //                     otpResent: true, 
    //                     loadingResendOtp: false
    //                 }, () => {
    //                     this.otpInput.focus();
    //                 });
    //             })
    //             .catch(err => {
    //                 // console.log("phoneNumber", phoneNumber);
    //                 console.error(err);
    //                 this.setState({
    //                     errorPhoneNumber: err,
    //                     loadingSendOtp: false
    //                 });
    //             });
    //     }
    // }


    // useDifferentNumber = () => {
    //     this.setState({
    //         // phoneNumber: "+1",
    //         otp: "",
    //         otpSent: false,
    //         otpResent: false,
    //         errors: [],
    //         loadingSendOtp: false,
    //         loadingConfirmOtp: false,
    //         loadingResendOtp: false,
    //         loadingConfirmResendOtp: false,

    //         timerOn: false,
    //         timerStart: 0,
    //         timerTime: 30000,

    //         basicFormCompleted: false
    //     }, () => {

    //         //   let docRefId = window.sessionStorage.getItem("loginToken");
    //         //   let loginTokenTimestamp = window.sessionStorage.getItem("loginTokenTimestamp");

    //         //   window.sessionStorage.setItem("referenceLoginToken", docRefId);
    //         //   window.sessionStorage.setItem("referenceLoginTokenTimestamp", loginTokenTimestamp);

    //         //   this.phoneNumberInput.focus();
    //     })
    // }


    render() {
        const {
            phoneNumber,
            email,
            firstName,
            lastName,
            otp,
            loadingSendOtp,
            loadingConfirmOtp,
            loadingConfirmEmail,
            timerOn,
            timerTime,
            otpResent,
            loadingResendOtp,
        } = this.state;

        return (
            <div className="app d-flex align-items-center justify-content-center w-100">
                <div className="app-block">
                    <div as="h1" icon className="my-3 my-md-4">

                        {!this.state.basicFormCompleted && !this.props.nonModal
                            && <div>
                                <h5>Por favor, preencha os campos para baixar o folheto</h5>
                            </div>
                            }

                        {this.state.emailSentCard
                            && 
                            (this.props.history.push(`/thankyou/`))
                            // <div>
                            //     <h3 className="text-center">Thank you</h3>
                            //     <p className="text-center">
                            //         <span className="h5">We have sent a download link on your email, </span>
                            //         <span className="ml-2 text-primary h5">{this.state.emailSentTo}</span>
                            //     </p>
                            // </div>
                        }

                    </div>
                    <form onSubmit={e => e.preventDefault()} size="large">
                        <div stacked>

                            {/* NEW APPROACH */}

                            {this.state.basicFormCompleted
                                ? <div>

                                    {this.state.updateEmailCard
                                        && <div>

                                            <h4>Hello, {this.state.previousUserData.displayName === undefined ? JSON.parse(window.localStorage.getItem("userDetails")).first_name : this.state.previousUserData.displayName}</h4>
                                            {this.state.emailNotFound
                                                ? <>
                                                    <p>It seems like you already have account with Igesia using <span className="text-primary">{this.state.previousUserData.phoneNumber === undefined ? JSON.parse(window.localStorage.getItem("userDetails")).mobile : this.state.previousUserData.phoneNumber}</span>, but your email is not linked yet.</p>
                                                </>
                                                : <>
                                                    <p>Please enter and confirm your email to get download link.</p>
                                                </>}

                                            <h5>Update email</h5>
                                            <div className="form-label-group">
                                                <input
                                                    fluid
                                                    name="updatedEmail"
                                                    placeholder="yourname@email.com"
                                                    onChange={this._handleChange}
                                                    value={this.state.updatedEmail}
                                                    className="form-control inputField"
                                                    type="email"
                                                />
                                                <label for="updatedEmail" className="mb-1">Email</label>
                                            </div>
                                            <div className="form-label-group">
                                                <input
                                                    fluid
                                                    name="confirmUpdatedEmail"
                                                    placeholder="yourname@email.com"
                                                    onChange={this._handleChange}
                                                    value={this.state.confirmUpdatedEmail}
                                                    className="form-control inputField"
                                                    type="email"
                                                />
                                                <label for="confirmUpdatedEmail" className="mb-1">Confirm email</label>
                                            </div>
                                            {this.state.updateEmailError && <p className="mb-0 small text-danger">Note: Please enter same email in both fields</p>}
                                            <button
                                                disabled={loadingConfirmEmail}
                                                className="btn btn-dark"
                                                onClick={this._handleEmailUpdate}
                                            >
                                                {loadingConfirmEmail && <Spinner animation="border" size="sm" className="mr-2" />}
                                            Confirm email
                                        </button>
                                            {!this.state.emailNotFound
                                                && <button
                                                    className="btn btn-outline-dark border-0"
                                                    onClick={() => this.setState({ updateEmailCard: false, promptForEmail: true })}
                                                >
                                                    Cancel
                                            </button>}
                                        </div>}

                                    {this.state.promptForEmail && ((this.state.email) && (this.state.email !== this.state.previousEmail)
                                        ? <div>
                                            <h4>Hello, {this.state.previousUserData.displayName === undefined ? JSON.parse(window.localStorage.getItem("userDetails")).first_name : this.state.previousUserData.displayName}</h4>
                                            <p>Looks like you already have an email <span className="font-weight-bold">{this.state.previousEmailVerified && "verified and "}attached</span> to your account <span className="text-primary">{this.state.previousEmail}</span>, do you wish to use this email?</p>

                                            <button
                                                className="btn btn-dark mt-3 mr-2"
                                                onClick={() => this._handlePromptWhichEmailToUse(this.state.previousEmail)}
                                            >
                                                {/* {loadingConfirmOtp && <Spinner animation="border" size="sm" className="mr-2" />} */}
                                                {/* Yes, use {this.state.previousEmail} */}
                                                Continue
                                            </button>
                                            <button
                                                className="btn btn-outline-dark border-0 mt-3"
                                                onClick={() => this._handlePromptWhichEmailToUse(this.state.email)}
                                            >
                                                {/* {loadingConfirmOtp && <Spinner animation="border" size="sm" className="mr-2" />} */}
                                                Use, {this.state.email}
                                            </button>
                                        </div>
                                        : <div>
                                            <h4>Hello, {this.state.previousUserData.displayName === undefined ? JSON.parse(window.localStorage.getItem("userDetails")).first_name : this.state.previousUserData.displayName}</h4>
                                            <p>Looks like you already have an email <span className="font-weight-bold">{this.state.previousEmailVerified && "verified and "}attached</span> to your account <span className="text-primary">{this.state.previousEmail}</span>, do you wish to use this email?</p>

                                            <button
                                                className="btn btn-dark mt-3 mr-2"
                                                onClick={() => this._handlePromptWhichEmailToUse(this.state.previousEmail)}
                                            >
                                                {/* {loadingConfirmOtp && <Spinner animation="border" size="sm" className="mr-2" />} */}
                                                {/* Yes, use {this.state.previousEmail} */}
                                                Continue
                                            </button>
                                            <button
                                                className="btn btn-outline-dark border-0 mt-3"
                                                onClick={() =>
                                                    this.setState({
                                                        updateEmailCard: true,
                                                        promptForEmail: false
                                                    }, () => {
                                                        if (this.state.email) {
                                                            this.setState({ updatedEmail: this.state.email })
                                                        }
                                                    })
                                                }
                                            >
                                                Use another email
                                            </button>
                                        </div>)}
                                </div>
                                : <div>
                                    {!this.state.otpSent && this.props.nonModal
                                        ? 
                                        <div className="p-3" >
                                        <Card  className="shadow-sm pt-4 pl-2 pr-2 pb-2 p-4" style={{backgroundColor: 'rgba(0,0,0,.03)'}}>
                                             <div>
                                                    <div className="mb-4">
                                                        <h5>Por favor, preencha os campos para baixar o folheto</h5>
                                                    </div>
                                                <div className="form-label-group bg-white rounded">
                                                    <input
                                                        fluid
                                                        name="firstName"
                                                        placeholder="First name"
                                                        onChange={this._handleChange}
                                                        value={firstName}
                                                        className="form-control px-2"
                                                        type="text"
                                                    />
                                                    <label for="firstName" className="mb-1">Primeiro nome</label>
                                                </div>
                                                <div className="form-label-group bg-white rounded">
                                                    <input
                                                        fluid
                                                        name="lastName"
                                                        placeholder="Last name"
                                                        onChange={this._handleChange}
                                                        value={lastName}
                                                        className="form-control px-2"
                                                        type="text"
                                                    />
                                                    <label for="lastName" className="mb-1">Sobrenome</label>
                                                </div>
                                                <div className="form-label-group bg-white rounded">
                                                    <input
                                                        fluid
                                                        name="email"
                                                        placeholder="yourname@email.com"
                                                        onChange={this._handleChange}
                                                        value={email}
                                                        className="form-control px-2"
                                                        type="email"
                                                    />
                                                    <label for="email" className="mb-1">E-mail</label>
                                                </div>
                                                {/* <p className="mb-1">Telefone</p> */}
                                                <div className="form-label-group bg-white rounded">
                                                    <input
                                                        fluid
                                                        name="phoneNumber"
                                                        // placeholder="+1"
                                                        onChange={this._handleChange}
                                                        value={phoneNumber}
                                                        className="form-control px-2"
                                                        type="tel"
                                                        pattern="\+[0-9\s\-\(\)]+"
                                                    />
                                                    <label for="phoneNumber" className="mb-1">Fone</label>
                                                </div>
                                                {this.state.errorPhoneNumber && <p className="small mb-1 mt-1 text-danger">{this.state.errorPhoneNumber.message}</p>}

                                                <div className="form-group text-center">
                                                    <button
                                                        disabled={loadingSendOtp}
                                                        className="btn btn-dark"
                                                        fluid
                                                        size="large"
                                                        onClick={this._handleSubmitAndGenerateOTP}
                                                    >
                                                        {loadingSendOtp && <Spinner animation="border" size="sm" className="mr-2" />}
                                                Enviar panfleto
                                        </button>
                                                </div>
                                            </div>
                                        </Card>
                                        </div>
                                        : !this.state.otpSent && !this.props.nonModal ?
                                        <div>
                                            <div className="form-label-group">
                                                <input
                                                    fluid
                                                    name="firstName"
                                                    placeholder="First name"
                                                    onChange={this._handleChange}
                                                    value={firstName}
                                                    className="form-control"
                                                    type="text"
                                                />
                                                <label for="firstName" className="mb-1">Primeiro nome</label>
                                            </div>
                                            <div className="form-label-group">
                                                <input
                                                    fluid
                                                    name="lastName"
                                                    placeholder="Last name"
                                                    onChange={this._handleChange}
                                                    value={lastName}
                                                    className="form-control"
                                                    type="text"
                                                />
                                                <label for="lastName" className="mb-1">Sobrenome</label>
                                            </div>
                                            <div className="form-label-group">
                                                <input
                                                    fluid
                                                    name="email"
                                                    placeholder="yourname@email.com"
                                                    onChange={this._handleChange}
                                                    value={email}
                                                    className="form-control"
                                                    type="email"
                                                />
                                                <label for="email" className="mb-1">E-mail</label>
                                            </div>
                                            <p className="mb-1">Telefone</p>
                                            <div className="form-label-group mb-0">
                                                <input
                                                    fluid
                                                    name="phoneNumber"
                                                    // placeholder="+1"
                                                    onChange={this._handleChange}
                                                    value={phoneNumber}
                                                    className="form-control"
                                                    type="tel"
                                                    pattern="\+[0-9\s\-\(\)]+"
                                                />
                                                <label for="phoneNumber" className="mb-1">Fone</label>
                                            </div>
                                            {this.state.errorPhoneNumber && <p className="small mb-1 mt-1 text-danger">{this.state.errorPhoneNumber.message}</p>}

                                            <div className="form-group mt-3">
                                                <button
                                                    disabled={loadingSendOtp}
                                                    className="btn btn-dark"
                                                    fluid
                                                    size="large"
                                                    onClick={this._handleSubmitAndGenerateOTP}
                                                >
                                                    {loadingSendOtp && <Spinner animation="border" size="sm" className="mr-2" />}
                                                Enviar panfleto
                                        </button>
                                            </div>
                                        </div>
                                        : <div>
                                            <p className="mb-1">Please enter the OTP sent on <span className="text-primary">{phoneNumber}</span></p>
                                            <div className="form-label-group mb-0">
                                                <input
                                                    fluid
                                                    name="otp"
                                                    placeholder="123456"
                                                    onChange={this._handleChange}
                                                    value={otp}
                                                    ref={(input) => { this.otpInput = input; }}
                                                    className="form-control inputField"
                                                    maxLength="6"
                                                />
                                                <label for="otp" className="mb-1">Enter OTP</label>
                                            </div>
                                            {this.state.errorOtp !== "" && <p className="small mb-1 mt-1 text-danger">{this.state.errorOtp}</p>}

                                            <div className="d-flex align-items-center">
                                                <button
                                                    disabled={loadingConfirmOtp}
                                                    className="btn btn-dark mt-3"
                                                    onClick={this._handleConfirmOTP}
                                                >
                                                    {loadingConfirmOtp && <Spinner animation="border" size="sm" className="mr-2" />}
                                                    Confirm OTP
                                                </button>
                                                <div className="ml-auto">
                                                    <div className="d-flex align-items-center justify-content-end">
                                                        {timerOn
                                                            ? <p className="text-muted mb-0 ml-2">Resend in {parseInt(timerTime / 1000) > 1 ? `${parseInt(timerTime / 1000)} seconds` : `${parseInt(timerTime / 1000)} second`}</p>
                                                            : <>
                                                            <p className="text-muted mb-0 py-2">Didn't get OTP?</p>
                                                            <button
                                                                disabled={otpResent}
                                                                className={otpResent ? "btn btn-outline-secondary btn-sm ml-2" : "btn btn-outline-primary btn-sm ml-2"}
                                                                onClick={this.handleResendSubmit}>
                                                                {loadingResendOtp && <Spinner animation="border" size="sm" className="mr-2" />}
                                                                Resend
                                                            </button>
                                                        </>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-end">
                                                <p className="text-muted mb-0">Or use different number, <a style={{ cursor: "pointer", color: "#6900ff" }} onClick={this.useDifferentNumber}><u>click here</u></a></p>
                                            </div>
                                        </div>}
                                </div>}


                            <input id="recaptcha-container" type="hidden" />
                            <input id="recaptcha-container-resend" type="hidden" />

                        </div>
                    </form>

                </div>
            </div>
        );
    };
}

export default RequestBrochure;